import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { uniq, startCase } from 'lodash';
import { useState } from 'react';
import { isValidNumberInputKey, strToInteger } from '@/utils/numbers';
import { Label, Input } from '@/components/FormElements';
import Button from '@/components/Button';
import RevealPill, { PillChip } from '@/components/Editor/Form/fields/RevealPill';
import parentStyles from '@/features/WidgetEdit/Form/styles.module.scss';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RADIUS_KEYS = ['topLeft', 'topRight', 'bottomLeft', 'bottomRight'];

const EditorFormFieldsBorderRadius = _ref => {
  let {
    nameSpace,
    label = 'Corner Radius',
    radius = {},
    defaults = {},
    openButtonVariant,
    onChange
  } = _ref;
  const {
    0: updatedAt,
    1: setUpdatedAt
  } = useState(Date.now());
  const isModified = RADIUS_KEYS.some(key => radius[key] !== undefined);
  const activeRadius = RADIUS_KEYS.map(key => radius[key] ?? defaults[key] ?? 0);
  const activeRadiusStr = uniq(activeRadius).length === 1 ? activeRadius[0] : activeRadius.join('-');

  const handleDelete = () => {
    // Reset all values to null
    onChange(RADIUS_KEYS.reduce((acc, key) => _objectSpread(_objectSpread({}, acc), {}, {
      [key]: null
    }), {}));
    setUpdatedAt(Date.now());
  };

  return /*#__PURE__*/_jsx(RevealPill, {
    label: label,
    activeState: /*#__PURE__*/_jsx(PillChip, {
      content: activeRadiusStr
    }),
    variant: isModified ? 'active' : '',
    openButtonVariant: openButtonVariant,
    children: /*#__PURE__*/_jsxs("div", {
      className: parentStyles.formField,
      children: [/*#__PURE__*/_jsx("div", {
        className: parentStyles.formField__grid,
        children: RADIUS_KEYS.map(key => {
          const fieldId = `${nameSpace}-radius-input-${key}`;
          return /*#__PURE__*/_jsx(RadiusInput, {
            id: fieldId,
            label: startCase(key),
            radius: radius[key],
            defaultValue: defaults[key],
            onChange: update => onChange({
              [key]: update
            })
          }, fieldId);
        })
      }), isModified ? /*#__PURE__*/_jsx(Button, {
        type: "button",
        variant: "delete",
        className: styles.deleteButton,
        onClick: handleDelete,
        children: "Reset to default"
      }) : /*#__PURE__*/_jsx(_Fragment, {})]
    })
  }, updatedAt);
};

const RadiusInput = _ref2 => {
  let {
    id,
    label,
    radius,
    defaultValue,
    onChange
  } = _ref2;
  return /*#__PURE__*/_jsx(Label, {
    forInput: id,
    text: label,
    children: /*#__PURE__*/_jsx(Input, {
      id: id,
      type: "number",
      placeholder: `${defaultValue ?? 0}`,
      min: 0,
      defaultValue: radius,
      onKeyDown: e => {
        if (!isValidNumberInputKey(e.key)) {
          e.preventDefault();
        }
      },
      onChange: evt => {
        const update = strToInteger(evt.target.value);
        onChange(update < 0 ? null : update);
      }
    })
  });
};

export default EditorFormFieldsBorderRadius;